<template>
  <div>
    <b-skeleton-wrapper :loading="periLoader">
      <template #loading>
        <b-skeleton
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>
      <div class="mb-75">
        <v-select
          id="periodo"
          placeholder="Clic aqui para seleccionar"
          label="clave"
          :value="per"
          :options="tiposPeri"
          :clearable="true"
          @input="(val) => $emit('tipoPeri', val)"
        />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import {
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onMounted } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'

export default {
  components: {
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
  },
  props: {
    per: {
      type: [Object, null],
      default: null,
    },
    esp: {
      type: [Number, null],
      default: null,
    },
    mat: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props, { emit }) {
    const tiposPeri = ref([])
    const toast = useToast()
    const periLoader = ref(false)
    const loadtiposPeri = () => {
      periLoader.value = true
      getData({ action: 14, token: store.state.cuenta.session.token, data: props.esp }, 'wsbajas')
        .then(response => {
          periLoader.value = false
          if (response.status === 200) {
            tiposPeri.value = response.data.data || []
            emit('catalogotiposPeri', tiposPeri.value)
            if (tiposPeri.value.length < 1) { emit('tipoPeri', null) }
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando periodos',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          periLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando periodos',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    onMounted(() => {
      if (props.esp !== null) { loadtiposPeri() }
    })
    return {
      tiposPeri,
      periLoader,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
